<div class="content">
    <span class="mat-title">Gerênciar recrutadores</span>

    <mat-list>
        <mat-list-item *ngFor="let company of companies">

            <h3 matLine>{{ company.businessname }}</h3>
            <p matLine>{{ company.companyname }}</p>
            <p matLine>{{ company.cnpj | mask:'00.000.000/0000-00' }}</p>

            <button mat-icon-button
                (click)="setShowUserData(true, company.id)"
                *ngIf="!company.show_user_data"
                matTooltip="Permitir a empresa de visualizar todos os dados dos usuários que não participam dos processos seletivos"
                color="primary">
                <mat-icon>person_off</mat-icon>
            </button>

            <button mat-icon-button
                (click)="setShowUserData(false, company.id)"
                *ngIf="company.show_user_data"
                matTooltip="Impedir a empresa de visualizar todos os dados dos usuários que não participam dos processos seletivos"
                color="primary">
                <mat-icon>person</mat-icon>
            </button>

            <button mat-icon-button color="primary" 
                *ngIf="company.voucher === null"
                (click)="setVoucher(true, company.id)"
                matTooltip="Habilitar voucher para candidatos da empresa">
                <mat-icon>unpublished</mat-icon>
            </button>

            <button mat-icon-button color="secondary" 
                *ngIf="company.voucher"
                (click)="setVoucher(false, company.id)"
                matTooltip="Desabilitar voucher para candidatos da empresa">
                <mat-icon>done</mat-icon>
            </button>

        </mat-list-item>
    </mat-list>

    <mat-paginator [length]="companiesTotal" (page)="onPageChange($event)"
        [pageSize]="20"
        [pageSizeOptions]="[10, 20, 50, 100]">
    </mat-paginator>

</div>